var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRhombusStroke30(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 4.829L4.828 15 15 25.172 25.172 15 15 4.83zM3.414 13.586a2 2 0 0 0 0 2.828l10.172 10.172a2 2 0 0 0 2.828 0l10.172-10.172a2 2 0 0 0 0-2.828L16.414 3.414a2 2 0 0 0-2.828 0L3.414 13.586z",
    clipRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE1IDQuODI5TDQuODI4IDE1IDE1IDI1LjE3MiAyNS4xNzIgMTUgMTUgNC44M3pNMy40MTQgMTMuNTg2YTIgMiAwIDAgMCAwIDIuODI4bDEwLjE3MiAxMC4xNzJhMiAyIDAgMCAwIDIuODI4IDBsMTAuMTcyLTEwLjE3MmEyIDIgMCAwIDAgMC0yLjgyOEwxNi40MTQgMy40MTRhMiAyIDAgMCAwLTIuODI4IDBMMy40MTQgMTMuNTg2eiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
export { SvgRhombusStroke30 as ReactComponent };